<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12 sm6)

                    // Form title (Meditation Details)
                    title-component(
                        type="h4"
                        :title="$t('sessions.general.subtitleSessionDetails')"
                    )

                    // Meditation Title input field
                    v-text-field(
                        name="title"
                        outline
                        v-model.lazy="model.title"
                        v-validate="'required|min:2|meditation_name'"
                        :data-vv-as="$t('fields.sessionName')"
                        :error-messages="errors.collect('title')"
                        :label="$t('fields.sessionName')"
                    )

                    // Meditation Feed Label input field
                    v-text-field(
                        name="title"
                        outline
                        v-model.lazy="model.feedLabel"
                        v-validate="'min:2'"
                        :data-vv-as="$t('fields.feedLabel')"
                        :error-messages="errors.collect('feedLabel')"
                        :label="$t('fields.feedLabel')"
                    )

                    // Meditation Title input field
                    v-text-field(
                        v-if="isLiveRecorded"
                        name="sessionLink"
                        :disabled="isEditing"
                        outline
                        v-model.lazy="model.video"
                        v-validate="'min:2'"
                        :data-vv-as="$t('fields.sessionLink')"
                        :error-messages="errors.collect('sessionLink')"
                        :label="$t('fields.sessionLink')"
                    )

                    // Meditation start time input field
                    v-text-field(
                        v-if="model.type === 'recorded'  && !isMindfulMinute"
                        name="startTime"
                        outline
                        v-model.lazy="model.startTime"
                        :label="$t('fields.startTime')"
                    )

                    // Meditation end time input field
                    v-text-field(
                        v-if="model.type === 'recorded'  && !isMindfulMinute"
                        name="endTime"
                        outline
                        v-model.lazy="model.endTime"
                        :label="$t('fields.endTime')"
                    )

                    // Description textarea field
                    v-textarea(
                        name="description"
                        rows="2"
                        outline
                        v-model.lazy="model.description"
                        v-validate="'required|min:2'"
                        :data-vv-as="$t('fields.sessionDescription')"
                        :error-messages="errors.collect('description')"
                        :label="$t('fields.sessionDescription')"
                    )

                    // Meditation Tags
                    v-text-field(
                        name="tags"
                        outline
                        v-model.lazy="model.tags"
                        v-validate="'required|min:2|max:512'"
                        :data-vv-as="$t('fields.tags')"
                        :error-messages="errors.collect('tags')"
                        :label="$t('fields.tags')"
                    )

                    // Assign Theme selection
                    v-select(
                        :disabled="isMindfulMinute"
                        v-if="(isRecorded  && !isMindfulMinute) || (isEditing && model.type === 'recorded' && !isMindfulMinute)"
                        name="theme"
                        append-icon="expand_more"
                        outline
                        v-model.lazy="model.theme"
                        :items="$t('selection.themes').slice(3)"
                        item-text="title"
                        :data-vv-as="$t('fields.theme')"
                        :v-validate="'required'"
                        :error-messages="errors.collect('theme')"
                        :label="$t('fields.theme')"
                    )

                    // Assign Instructor selection
                    v-select(
                        v-if="!isMindfulMinute"
                        name="instructorId"
                        append-icon="expand_more"
                        outline
                        v-model.lazy="model.instructorId"
                        :items="instructors"
                        :data-vv-as="$t('fields.assignInstructor')"
                        :error-messages="errors.collect('instructorId')"
                        :label="$t('fields.assignInstructor')"
                    )

                    // Lock Meditation checkbox
                    v-checkbox.mt-0(
                        v-if="!isMindfulMinute"
                        v-model="model.isLocked"
                        :label="$t('fields.locked')"
                    )

                    // Assign to all businesses checkbox
                    v-checkbox.mt-0(
                        v-if="!isMindfulMinute"
                        v-model="model.assignedToAll"
                        :label="$t('fields.assignedToAll')"
                    )

                    // Is Suggested session checkbox
                    v-checkbox.mt-0(
                        v-if="!isMindfulMinute"
                        v-model="model.isSuggested"
                        :label="$t('fields.isSuggested')"
                    )

                    // Assign to all businesses checkbox
                    v-checkbox.mt-0(
                        v-if="!isRecorded"
                        v-model="useDefaultImage"
                        :label="$t('fields.useDefaultImage')"
                    )

                    // Archive checkbox
                    v-checkbox.mt-0(
                        v-if="isEditing && (model.type === 'recorded' || model.type === 'archived') && !isMindfulMinute"
                        v-model="model.isArchived"
                        :label="$t('fields.archived')"
                    )

                    // CHILL Check-in checkbox
                    v-checkbox.mt-0(
                        v-if="!isMindfulMinute && !isRecorded"
                        v-on:change="checkInChangeHandler"
                        :value="!(model.check_in_duration === 0)"
                        :label="$t('fields.enableChillCheckIn')"
                    )

                v-flex(xs12 sm6)
                    div(v-if="!isRecorded")
                        // Form title (Date and Time)
                        title-component(
                            type="h4"
                            :title="$t('sessions.general.subtitleDateAndTime')"
                        )

                        // Date Picker field
                        v-date-picker.c-datepicker(
                            color="primary"
                            header-color="primary"
                            full-width
                            reactive
                            outline
                            v-model="model.date"
                            :min="currentDay"
                            :landscape="landscape"
                        )

                        // Time Picker field
                        time-picker.my-3(
                            :label="$t('fields.startTime')"
                            :timePickerCallback="timePickerCallback"
                            :predefinedTime="model.time"
                        )

                    div(v-if="isRecorded") {{ file }}
                        title-component(
                            type="h4"
                            :title="$t('sessions.general.subtitleUploadVideo')"
                        )

                        // video upload component
                        video-upload.mb-3(
                            :uploadVideoCallback="uploadVideoCallback"
                            :videoName="model.videoName"
                        )

                    title-component(
                        type="h4"
                        :title="$t('sessions.general.subtitleUploadPhoto')"
                    )

                    div.uploadWrapper.mt-3(v-if="!model.poster")

                        div
                            // Upload image button
                            upload-button.ml-0(
                                id="avatar"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                :ext="'image/jpeg,image/png,image/jpg'"
                                :selectedCallback="uploadSessionImage"
                            )
                                span {{ $t('defaultButtons.uploadImage') }}


                    div(v-else)
                        image-preview(:url="model.poster" :name="model.poster_name" :deleteCallback="deleteImage")

            v-layout(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.actions
                        div

                            // Delete button
                            a.deleteAction(
                                v-if="isEditing"
                                :isLoading="isLoading"
                                @click="deleteSession"
                            )
                                v-icon(grey) delete
                                | {{ $t('sessions.edit.delete.button') }}

                        div.controls
                            div
                                // Cancel button
                                button-component.ml-0(
                                    color="grey"
                                    large
                                    outline
                                    :isLoading="isLoading"
                                    :action="cancel"
                                ) {{ $t('defaultButtons.cancel') }}

                            div
                                // Submit button
                                button-component.mr-0.submit(
                                    color="primary"
                                    large
                                    :isLoading="isLoading"
                                    :action="submit"
                                ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import TimePicker from '~components/Picker/TimePicker';
    import Title from '~components/Title';
    import ImagePreview from '~components/ImagePreview';

    import UploadButton from '~components/UploadButton';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import formattedDate from '~filters/FormattedDate';
    import formattedTime from '~filters/FormattedTime';
    import VideoUpload from './VideoUpload';
    import dayjs from 'dayjs';
    import VueTypes from 'vue-types';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            VideoUpload,
            UploadButton,
            TimePicker,
            ImagePreview,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        filters: {
            formattedDate,
            formattedTime
        },
        props: {
            isMindfulMinute: VueTypes.bool.def(false),
            isRecorded: VueTypes.bool.def(false),
            isLiveRecorded: VueTypes.bool.def(false),
            isEditing: VueTypes.bool.def(false),
            id: VueTypes.string.def('')
        },
        data() {
            return {
                file: null,
                currentDay: dayjs().format('YYYY-MM-DD'),
                useDefaultImage: false,
                defaultLiveImage:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/live-screen-min.jpeg'
            };
        },
        created() {
            if (this.isMindfulMinute) this.model.theme = 'minutes';
            if (this.isLiveRecorded) this.model.videoName = 'recorded-live';
        },
        computed: {
            ...mapFields('sessions', {
                model: 'session',
                settingsParam: 'settingsParam'
            }),
            ...mapGetters('sessions', [
                'isLoading',
                'instructors',
                'businesses'
            ]),

            /**
             * Change landscape on small devices
             * @returns {boolean}
             */
            landscape: function() {
                return this.$vuetify.breakpoint.mdAndUp;
            }
        },
        watch: {
            useDefaultImage(val) {
                if (val) {
                    this.model.poster = this.defaultLiveImage;
                    this.model.poster_name = 'Default Image';
                } else {
                    this.model.poster = null;
                    this.model.poster_name = null;
                }
            }
        },
        beforeMount() {
            // Get instructors for selection
            this.readInstructors();
        },
        methods: {
            ...mapActions('sessions', [
                'create',
                'update',
                'cancel',
                'deleteSession',
                'readInstructors',
                'uploadImage'
            ]),
            ...mapActions('snackbar', ['showMessage']),

            /**
             * Update Session on submit
             * @returns {Promise<void>}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                if (!this.model.poster) {
                    return this.showMessage(
                        this.$t('sessions.edit.errorMessageAvatar')
                    );
                }

                if (this.model.date && this.model.time) {
                    const currentDate = dayjs(new Date());
                    const meditationDate = dayjs(
                        `${this.model.date} ${this.model.time}`
                    );
                    const diffTime = meditationDate.diff(currentDate, 'second');

                    if (diffTime > 0 && diffTime <= 659) {
                        return this.showMessage(
                            this.$t('sessions.edit.errorMessageStartedAt')
                        );
                    }
                }

                if (!this.isRecorded && this.model.type !== 'recorded') {
                    this.model.theme = 'live';
                }

                if (this.isEditing) return this.update();

                return this.create();
            },

            /**
             * Time Picker callback
             * @param {string} e
             */
            timePickerCallback(e) {
                this.model.time = e;
            },

            /**
             * Upload meditation image
             * @param {file} e
             * @returns {Promise<void>}
             */
            async uploadSessionImage(e) {
                let formData = new FormData();
                formData.append('name', e.name);
                formData.append('photo', e);
                const resp = await this.uploadImage(formData);

                if (resp.ok) {
                    this.model.poster = resp.data;
                    this.model.poster_name = e.name;
                }
            },

            /**
             * Upload video callback
             * @param link
             */
            uploadVideoCallback(params) {
                this.model.video = params.url;
                this.model.videoName = params.videoName;
            },

            /**
             * Chill Check-in handler
             */
            checkInChangeHandler(v) {
                this.model.check_in_duration = v ? 600 : 0;
            },

            deleteImage() {
                this.model.poster = null;
                this.model.poster_name = '';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    >>> .v-textarea textarea
        resize: none

    .marginRight
        margin-right: 20px

    .marginTop
        margin-top: 20px

    .fileName
        max-width: 50%
        margin-bottom: 15px

    .saveSettings
        display: flex
        align-items flex-end

        .expireOn
            flex: 1 1 50%

        .replaceWith
            flex: 1 1 50%

        .v-input--selection-controls
            margin-top: 0

    .actions
        display: flex
        align-items: center
        justify-content: space-between

        .deleteAction
            display: flex
            align-items: center
            text-decoration: none
            font-size: 14px
            color: $theme.white

            .v-icon
                padding-right: 5px
                color: $theme.darkGrey

        .controls
            width: auto

    .coverPhotoWrapper
        margin-top: 12px

    .uploadWrapper
        display: flex
        align-items: center
        flex-direction: row

    .removeButton
        padding-left: 5px

    .ellipsis
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
        max-width: 100%

    >>> .v-select__selection
        display: inline-block
        overflow: hidden
        white-space: nowrap
        text-overflow: ellipsis

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .saveSettings
            display: flex
            align-items flex-start
            flex-direction: column

            .expireOn
                flex: 1 1 100%
                width: 100%

            .replaceWith
                flex: 1 1 100%
                width: 100%

        .marginRight
            margin-right: 0

        .coverPhotoWrapper
            margin-top: 9px

    .uploadWrapper
        display: flex
        align-items: center

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .actions
            flex-direction: column
            justify-content: space-between

            .deleteAction
                margin-bottom: 10px

            .controls
                width: 100%

                div
                    width: 50%
</style>
